export default __webpack_public_path__ + "static/media/cover-photo.949185f4.jpg";